import { render } from "./take_money_to_launderer.vue?vue&type=template&id=04153fe8"
import script from "./take_money_to_launderer.vue?vue&type=script&lang=js"
export * from "./take_money_to_launderer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__